module.exports = __webpack_public_path__ + "static/media/project12.4df51593.jpg";